export type Edge<T> = { node?: T | null } | null | undefined;

export function flattenPostEdges<T>(
  edges: Array<Edge<T>> | null | undefined
): T[] {
  if (!edges) return [];
  const nodes: T[] = [];
  for (const edge of edges) {
    if (edge?.node) nodes.push(edge.node);
  }
  return nodes;
}

export function normalizeThumbnail(thumbnail?: string | null) {
  if (!thumbnail) return null;

  const raw = thumbnail.trim();
  if (!raw || raw === "null") return null;

  if (raw.startsWith("/")) return raw;
  if (raw.startsWith("optimised/")) return `/${raw}`;

  if (raw.startsWith("http") || raw.startsWith("//")) {
    const resolved = raw.startsWith("//") ? `https:${raw}` : raw;
    try {
      const url = new URL(resolved);
      const host = url.hostname.toLowerCase();
      const isTinaHost = host.endsWith("tina.io") || host.endsWith("tinajs.io");
      const optimisedIndex = url.pathname.indexOf("/optimised/");
      const optimisedFromPath =
        optimisedIndex !== -1 ? url.pathname.slice(optimisedIndex) : null;
      const filename = url.pathname.split("/").filter(Boolean).pop();
      const optimisedFallback =
        optimisedFromPath ?? (filename ? `/optimised/${filename}` : null);

      // Some legacy Tina assets 404 but we keep local copies under /public/optimised.
      if (isTinaHost && optimisedFallback) return optimisedFallback;

      return resolved;
    } catch {
      return resolved;
    }
  }

  return `/${raw}`;
}

export function normalizeThumbnails<T extends { thumbnail?: string | null }>(
  posts: T[]
): T[] {
  return posts.map((post) => ({
    ...post,
    thumbnail: normalizeThumbnail(post.thumbnail),
  })) as T[];
}
